import {
    renderAircraft,
    renderAirportDirectory,
    renderDispatch,
    renderDocs,
    renderFleetTracking,
    renderOrg,
} from '../MenuItems';
import fillSpace from '../MenuItems/FillSpace';
import { RenderMenuParams } from 'ff/common/components/FFMenuV2/RenderMenuParams';

export default function RenderFspMenu({ currentUser }: RenderMenuParams) {
    const {
        dispatch_tools,
        isOrgUserAdmin,
        isOrgAircraftAdmin,
        isOrgFlightsAdmin,
        isFspAdmin,
        isFspFlightManager,
        isOrgDocumentsAdmin,
        isFF_FspAdmin,
    } = currentUser;

    const toReturn = [];

    if (
        isFF_FspAdmin ||
        ((isOrgFlightsAdmin ||
            isFspAdmin ||
            isFspFlightManager ||
            isOrgDocumentsAdmin) &&
            dispatch_tools)
    )
        toReturn.push(renderDispatch);

    toReturn.push(renderFleetTracking);

    if (isOrgAircraftAdmin) toReturn.push(renderAircraft);

    toReturn.push(renderAirportDirectory);

    if (isOrgUserAdmin) toReturn.push(renderOrg);

    if (isOrgDocumentsAdmin) toReturn.push(renderDocs);

    toReturn.push(fillSpace.bind(null, { flex: '1' }));
    return toReturn;
}
